/**
 * Resource management mode (R1 / Phase 0 of the enterprise resource model).
 *
 * A workspace is either in **Standard** mode (today's behaviour — simple
 * per-person rates, one role per person, free-text departments) or
 * **Enterprise** mode (rate cards, multiple roles + skill proficiency,
 * managed departments + resource managers).
 *
 * The stored value lives on `organizations.resource_mode` (migration 0066).
 * It is only honoured when the workspace is on the Enterprise tier — see
 * `useResourceMode()`, which forces 'standard' otherwise so a downgrade hides
 * the enterprise UI gracefully without touching the stored value.
 *
 * See docs/resources-enterprise-model-spec.md.
 */

export type ResourceMode = 'standard' | 'enterprise';

export const DEFAULT_RESOURCE_MODE: ResourceMode = 'standard';

/** localStorage key used to persist the mode in demo / localStorage mode. */
export const RESOURCE_MODE_STORAGE_KEY = 'projexhq:resourceMode';

/** Coerce an unknown/raw value to a valid ResourceMode (defaults to standard). */
export function normalizeResourceMode(raw: unknown): ResourceMode {
  return raw === 'enterprise' ? 'enterprise' : 'standard';
}
